import JwtService from "@/services/jwt.service";
let user = JwtService.getUser();

export function aclMenu(list) {
    let filtered = [];
    try {
        if(user.is_admin == true || user.user_group == '*') {
            return list;
        }
        // const permissions = user.config.permissions;
        // filtered = list.filter(item => permissions.includes(item.id));

        // const permissions = user.config.permissions.map((item) => item.value);
        const permissions = user.config.permissions;
        filtered = list.filter(item => permissions.includes(item));
    } catch(error) {
        // console.log("error", "aclMenu")
        filtered = [];
    }
    return [...filtered];
}

export function getAclMenuFromParameters(parameters, key) {
    try {
        const menu = JSON.parse(parameters[key].value);
        if(Array.isArray(menu) && menu.length) {
          return aclMenu(menu);
        }
    } catch(error) {
     // console.log("error", error)
    }
    return null;
}